import { render } from "./WorkingSchedule.vue?vue&type=template&id=ba051dd2"
import script from "./WorkingSchedule.vue?vue&type=script&lang=js"
export * from "./WorkingSchedule.vue?vue&type=script&lang=js"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__